// extracted by mini-css-extract-plugin
export default {"main":"styles_main__dDwAj","blue1":"styles_blue1__6RS3d","blue2":"styles_blue2__79eN9","blue3":"styles_blue3__JvvF9","white":"styles_white__IvtSE","grey":"styles_grey__+BvTX"};